import {
  ASSIGNED_NODE_TAG,
  COMMENT_NODE_TAG,
  DOCUMENT_NODE_TAG,
  POLYFILL_SHADOW_NODE_TAG,
  SHADOW_NODE_TAG,
  TEXT_NODE_TAG,
} from '@fullstory/shared/node_decoder';
import { FsAssignedNodes } from './fsassignednodes';
import { FsCanvas } from './fscanvas';
import { FsComment } from './fscomment';
import { FsLinkElement, FsStyleElement } from './fscssomelement';
import { FsDocumentNode, FsPolyfillShadowRoot, FsShadowRoot } from './fsdocumentorshadowroot';
import { FsDocumentType } from './fsdocumenttype';
// eslint-disable-next-line import/no-cycle
import { FsFrameElement, FsIFrameElement } from './fsframelikeelement';
import { FsHeadElement } from './fsheadelement';
import {
  FsEmbedElement,
  FsImageElement,
  FsObjectElement,
  FsSvgImageElement,
} from './fsimagelikeelement';
import { FsAudioElement, FsVideoElement } from './fsmediaelement';
import type { FsNode } from './fsnode';
import { FsNoScriptElement } from './fsnoscriptelement';
import { FsSlotElement } from './fsslotelement';
import { FsText } from './fstext';

/** A map from tag names to the constructor used to construct them. */
export const FsNodeConstructorMap = {
  [COMMENT_NODE_TAG]: FsComment,
  [DOCUMENT_NODE_TAG]: FsDocumentNode,
  [POLYFILL_SHADOW_NODE_TAG]: FsPolyfillShadowRoot,
  [SHADOW_NODE_TAG]: FsShadowRoot,
  [TEXT_NODE_TAG]: FsText,
  [ASSIGNED_NODE_TAG]: FsAssignedNodes,
  '!doctype': FsDocumentType,
  audio: FsAudioElement,
  embed: FsEmbedElement,
  frame: FsFrameElement,
  head: FsHeadElement,
  iframe: FsIFrameElement,
  img: FsImageElement,
  image: FsSvgImageElement,
  link: FsLinkElement,
  noscript: FsNoScriptElement,
  object: FsObjectElement,
  script: FsNoScriptElement,
  slot: FsSlotElement,
  style: FsStyleElement,
  video: FsVideoElement,
  canvas: FsCanvas,
};

type ConstructorReturnType<C> = C extends new (...args: any[]) => infer T ? T : never;

type FsNodeConstructorTypeMap = typeof FsNodeConstructorMap;

type FsNodeTypeMap = {
  [TagName in keyof FsNodeConstructorTypeMap]: ConstructorReturnType<
    FsNodeConstructorTypeMap[TagName]
  >;
};

/** A map from tag names to the type of FsNode they generate. */
export type FsNodeMap = {
  [index: string]: FsNode;
} & FsNodeTypeMap;
